"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var ColorUtils_2 = require("Common/Utils/ColorUtils/ColorUtils");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var CommonBlockStyleShortcut = (function (_super) {
    __extends(CommonBlockStyleShortcut, _super);
    function CommonBlockStyleShortcut(props) {
        var _this = _super.call(this, props) || this;
        _this.showCustomColor = false;
        _this.trackOnly = function (parameters) {
            var _a = _this.props, telemetry = _a.telemetry, blockStore = _a.blockStore;
            return telemetry.trackOnly("Block Styles Shortcuts Changed", __assign({ block_styles_shortcuts_type: blockStore.blockType }, parameters), {
                blockIntercom: true,
                blockIdentify: true,
            });
        };
        _this.handleColorButtonOnClick = function (color) {
            _this.showCustomColor = false;
            _this.handleBackgroundColorChange(color);
        };
        _this.handleBackgroundColorChange = function (color) {
            var _a = _this.props, blockStyleStore = _a.blockStore.blockStyleStore, handleBackgroundChange = _a.handleBackgroundChange;
            var newBackground = __assign({}, blockStyleStore.model.background);
            newBackground.abs =
                newBackground.opacity == null ? color.value : (0, ColorUtils_1.replaceOpacity)(color.value, newBackground.opacity);
            newBackground.themeIndex = color.themeIndex;
            blockStyleStore.setStylePropsByKey("background", newBackground);
            _this.trackOnly({
                block_styles_shortcuts_block_color: (0, ColorUtils_2.getTelemetryColor)(color),
            });
            if (handleBackgroundChange) {
                handleBackgroundChange(color);
            }
        };
        _this.handleBlockWidthChange = function (blockWidth) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            blockStyleStore.setStylePropsByKey("blockWidth", blockWidth);
            _this.trackOnly({
                block_styles_shortcuts_block_width: blockWidth,
            });
        };
        _this.handleBlockSpacingChange = function (blockSpacing) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            blockStyleStore.setStylePropsByKey("blockSpacing", blockSpacing);
            _this.trackOnly({
                block_styles_shortcuts_block_spacing: blockSpacing,
            });
        };
        _this.handleBlockHeightChange = function (blockHeight) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            blockStyleStore.setStylePropsByKey("blockHeight", blockHeight);
            _this.trackOnly({
                block_styles_shortcuts_block_height: _this.blockModelHeightToTelemetryName(blockHeight),
            });
        };
        _this.blockModelHeightToTelemetryName = function (blockHeight) {
            var _a;
            return ((_a = {},
                _a["small"] = "1/3",
                _a["medium"] = "1/2",
                _a["large"] = "full",
                _a["none"] = "none",
                _a)[blockHeight]);
        };
        var blockStyleStore = props.blockStore.blockStyleStore;
        var isCustomColorApplied = blockStyleStore.model.background.themeIndex == null;
        _this.showCustomColor = isCustomColorApplied;
        return _this;
    }
    CommonBlockStyleShortcut.prototype.render = function () {
        var _a = this.props, blockWidthOptions = _a.blockWidthOptions, blockSpacingOptions = _a.blockSpacingOptions, blockHeightOptions = _a.blockHeightOptions, colorSectionTitle = _a.colorSectionTitle, _b = _a.blockStore, blockStyleStore = _b.blockStyleStore, blockType = _b.blockType, children = _a.children, usingFeature = _a.usingFeature;
        var showCustomColor = this.showCustomColor;
        var _c = blockStyleStore.model, background = _c.background, blockWidth = _c.blockWidth, blockSpacing = _c.blockSpacing, blockHeight = _c.blockHeight;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !(usingFeature(FeatureFlag_1.FeatureFlag.TextBlockBackgroundStylingMenu) && blockType === commonTypes_1.BlockType.Text) && (react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__color-section-container" },
                    react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, colorSectionTitle)),
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(ColorPalette_1.default, { theme: "light", onColorChange: this.handleColorButtonOnClick, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(background), this.presetBackgroundColors), presetColors: this.presetBackgroundColors, key: "color-palette--".concat(showCustomColor ? "inactive" : "active"), type: "block" })))),
            children,
            react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Block width", size: kaleidoscope_1.SegmentedControlSize.Medium, options: blockWidthOptions, selectedValue: blockWidth, onClickHandler: this.handleBlockWidthChange }))),
            react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Block spacing", size: kaleidoscope_1.SegmentedControlSize.Medium, options: blockSpacingOptions, selectedValue: blockSpacing, onClickHandler: this.handleBlockSpacingChange })),
            usingFeature(FeatureFlag_1.FeatureFlag.TextBlockBackgroundStylingMenu) &&
                blockType === commonTypes_1.BlockType.Text &&
                blockHeightOptions && (react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Minimum height", size: kaleidoscope_1.SegmentedControlSize.Medium, options: blockHeightOptions, selectedValue: blockHeight || "none", onClickHandler: this.handleBlockHeightChange })))));
    };
    Object.defineProperty(CommonBlockStyleShortcut.prototype, "presetBackgroundColors", {
        get: function () {
            var _a = this.props, brandStore = _a.brandStore, blockStyleStore = _a.blockStore.blockStyleStore;
            if (blockStyleStore.model.blockType === commonTypes_1.BlockType.Splash) {
                return brandStore.colorsWithThemeIndex.filter(function (color) {
                    return color.themeIndex !== DefaultColors_1.DEFAULT_GREY10.themeIndex;
                });
            }
            else {
                return brandStore.colorsWithThemeIndex;
            }
        },
        enumerable: false,
        configurable: true
    });
    CommonBlockStyleShortcut.defaultProps = {
        colorSectionTitle: "block color",
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], CommonBlockStyleShortcut.prototype, "showCustomColor", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommonBlockStyleShortcut.prototype, "handleColorButtonOnClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommonBlockStyleShortcut.prototype, "handleBackgroundColorChange", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], CommonBlockStyleShortcut.prototype, "presetBackgroundColors", null);
    CommonBlockStyleShortcut = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], CommonBlockStyleShortcut);
    return CommonBlockStyleShortcut;
}(react_1.default.Component));
exports.default = CommonBlockStyleShortcut;
